








































































































import Vue from "vue";
import ApiService from "../../services/ApiService";
import SingleParent from "@/modals/SingleParent.vue";
export default Vue.extend({
  data() {
    return {
      data: [],
      loading: true,
      first_name: "",
      last_name: "",
      email: "",
    };
  },
  methods: {
    handleClick() {
      alert("this is it");
    },
    getParents() {
      ApiService.generalApi.getSchoolParents().then((resp) => {
        const data = resp.data;
        data.forEach((element) => {
          element.parent_name = element.first_name + " " + element.last_name;
        });
        this.loading = false;
        this.data = data;
      });
    },
    openParent(userId) {
      this.$modal.show(
        SingleParent,
        {
          options: {
            profilePicture: true,
          },
          userId,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          height: 700,
          adaptive: true,
          width: 1100,
          // pivotY: 0
        },
        {
          "before-close": this.beforeClose,
        }
      );
    },
    beforeClose() {
      this.getParents();
    },
  },
  mounted() {
    this.getParents();
  },
});
